import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var advisoryURLs = {
    uploadCAS: URLConfig.config.apiBase +
        microService.casAdvisoryService +
        "casadvisory/UploadPdf",
    casUploadHistory: URLConfig.config.apiBase +
        microService.casAdvisoryService +
        "casadvisory/uploadhistory",
    casUploadSummary: URLConfig.config.apiBase +
        microService.casAdvisoryService +
        "casadvisory/uploadsummary",
    syncNuvamaPortfolio: URLConfig.config.apiBase + microService.casAdvisoryService + "casadvisory/syncnuvamaportfolio",
};
export default advisoryURLs;
